<template>
  <template v-if="iframe && renderHeader">
    <div class="mx-2 shadow bg-white flex items-center justify-between py-5 px-3 md:px-10 mb-5">
      <div class="flex flex-col">
        <p class="font-bold">{{ getCurrentUser.landlord.company_name }}</p>
        <p>{{ getCurrentUser.landlord.address }}</p>
        <p>{{ getCurrentUser.landlord.phone }}</p>
        <p>{{ getCurrentUser.landlord.contact_email }}</p>
        <p>{{ getCurrentUser.landlord.website }}</p>
      </div>

      <div class="flex items-center">
        <img :src="getCurrentUser.landlord.logo" style="width: 200px" />
      </div>
    </div>
  </template>

  <div
    class="mx-2 md:mx-0 shadow bg-white py-5 px-3 md:px-10"
    :class="[
      !iframe
        ? 'panel-container md:rounded application md:overflow-y-scroll'
        : 'application-frame w-fit'
    ]"
  >
    <div v-if="getCurrentApplication">
      <div
        v-for="(section, sectionIndex) in getCurrentApplication.form.sections"
        :key="`${section.section_id}-${sectionIndex}`"
      >
        <div class="border border-brand-mid-gray mb-2" v-if="sectionIndex !== 0"></div>
        <h2 class="py-4">{{ section.label }}</h2>

        <div class="flex flex-col">
          <div
            class="flex flex-col md:flex-row justify-between py-5 page-break"
            v-for="(field, fieldIndex) in section.fields"
            :key="field.name"
            :class="[
              fieldIndex !== 0 ? 'border-t border-brand-light-gray' : '',
              (fieldIndex + 1) % 2 === 0 ? 'bg-brand-light-gray' : 'bg-white'
            ]"
          >
            <FieldDisplay :field="field" mode="view" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex"

export default {
  computed: {
    ...mapGetters(["getCurrentApplication", "getCurrentUser"]),
    renderHeader() {
      if (!this.iframe) {
        return false
      }

      if (!this.getCurrentApplication || !this.getCurrentUser) {
        return false
      }

      return (
        this.getCurrentUser.landlord.logo &&
        this.getCurrentUser.landlord.company_name &&
        this.getCurrentUser.landlord.contact_email
      )
    }
  },
  mounted() {
    if (this.$route.query.iframe) {
      this.iframe = this.$route.query.iframe
    }
  },
  data() {
    return {
      iframe: false
    }
  }
}
</script>
<style lang="scss" scoped>
.panel-container {
  min-height: 90vh;
  height: 100%;
}
@screen md {
  .panel-container {
    height: 700px;
  }
}
</style>
